import * as React from 'react';
import { Link } from 'react-router-dom';

import './utils/a-button.scss';

type ButtonType = 'button' | 'submit' | 'reset';

interface Props {
  buttonColor?: string;
  buttonSize?: string;
  buttonType?: string;
  buttonUrl?: string;
  onClick?: (event: any) => any;
  onSubmit?: (event: any) => any;
  otherClasses?: string;
  otherId?: string;
  children?: any;
  isButton?: boolean;
  isRound?: boolean;
  dataAttribute?: string;
  dataRemote?: boolean;
  targetBlank?: boolean;
  disabled?: boolean;
  extraStyle?: React.CSSProperties;
  reactRouterLink?: boolean;
}

/**
 * Component which renders a standardized button
 */

export default class Button extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  classNameConstructor(props) {
    let classy = 'lw-button';

    if (props.buttonColor) {
      classy += ` lw-button--${props.buttonColor}`;
    } else {
      classy += ' lw-button--puertoRico';
    }

    if (props.buttonSize) {
      classy += ` lw-button--${props.buttonSize}`;
    } else {
      classy += ' lw-button--mid';
    }

    if (props.buttonType) {
      classy += ` lw-button--${props.buttonType}`;
    }

    if (props.otherClasses) {
      classy += ' ' + props.otherClasses;
    }

    if (props.isRound) {
      classy += ' lj-button--round';
    }

    return classy;
  }

  render() {
    if (this.props.isButton) {
      return (
        <button
          style={this.props.extraStyle}
          className={this.classNameConstructor(this.props)}
          onClick={this.props.onClick}
          onSubmit={this.props.onClick}
          id={this.props.otherId}
          data-attribute={this.props.dataAttribute}
          data-remote={this.props.dataRemote}
          disabled={this.props.disabled}
          type={this.props.buttonType as ButtonType}
        >
          {this.props.children}
        </button>
      );
    } else if (this.props.reactRouterLink) {
      return (
        <Link
          style={this.props.extraStyle}
          to={this.props.buttonUrl}
          className={this.classNameConstructor(this.props)}
          id={this.props.otherId}
          data-attribute={this.props.dataAttribute}
          data-remote={this.props.dataRemote}
          onClick={this.props.onClick}
        >
          {this.props.children}
        </Link>
      );
    } else {
      return (
        <a
          style={this.props.extraStyle}
          href={this.props.buttonUrl}
          className={this.classNameConstructor(this.props)}
          id={this.props.otherId}
          data-attribute={this.props.dataAttribute}
          data-remote={this.props.dataRemote}
          onClick={this.props.onClick}
          target={this.props.targetBlank ? '_blank' : '_self'}
          rel='noreferrer'
        >
          {this.props.children}
        </a>
      );
    }
  }
}
